export default "__VITE_ASSET__4705314c__"